"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _PinnedEngagementActionTypes = _interopRequireDefault(require("crm_ui/pinnedEngagements/actions/PinnedEngagementActionTypes"));

var _PinnedEngagementsActions = require("crm_ui/pinnedEngagements/actions/PinnedEngagementsActions");

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _LazyKeyStore = require("crm_data/store/LazyKeyStore");

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _makeBatch = _interopRequireDefault(require("crm_data/api/makeBatch"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var PIN_ENGAGEMENT = _PinnedEngagementActionTypes.default.PIN_ENGAGEMENT,
    UNPIN_ENGAGEMENT = _PinnedEngagementActionTypes.default.UNPIN_ENGAGEMENT;
var batchFetch = (0, _makeBatch.default)(function (id) {
  var objectType = id.get('objectType');
  var subjectId = id.get('subjectId');
  return (0, _PinnedEngagementsActions.getPinnedEngagement)(objectType, subjectId);
}, 'PinnedEngagementsStore.getPinnedEngagement');

var _makeKey = function _makeKey(objectType, subjectId) {
  return (0, _immutable.Map)({
    objectType: objectType,
    subjectId: subjectId
  });
};

(0, _LazyKeyStore.registerLazyKeyService)({
  namespace: _ActionNamespaces.PINNED_ENGAGEMENT,
  fetch: batchFetch
});
var PinnedEngagementsStore = (0, _LazyKeyStore.defineLazyKeyStore)({
  idIsValid: function idIsValid(key) {
    return _immutable.Map.isMap(key) && typeof key.get('subjectId') === 'string' && typeof key.get('objectType') === 'string';
  },
  namespace: _ActionNamespaces.PINNED_ENGAGEMENT
}).defineResponseTo(PIN_ENGAGEMENT, function (state, _ref) {
  var subjectId = _ref.subjectId,
      objectType = _ref.objectType,
      engagementId = _ref.engagementId;

  var key = _makeKey(objectType, subjectId);

  return state.set(key, engagementId);
}).defineResponseTo(UNPIN_ENGAGEMENT, function (state, _ref2) {
  var subjectId = _ref2.subjectId,
      objectType = _ref2.objectType;

  var key = _makeKey(objectType, subjectId);

  return state.set(key, _LoadingStatus.EMPTY);
}).defineResponseTo(_ActionTypes.ENGAGEMENTS_UPDATED, function (state, engagementsMap) {
  var deletedPinnedEngagementId = state.valueSeq().find(function (engagementId) {
    return engagementsMap.has(engagementId) && engagementsMap.get(engagementId) === null;
  });

  if (deletedPinnedEngagementId) {
    var key = state.findKey(function (engagementId) {
      return engagementId === deletedPinnedEngagementId;
    });
    return state.set(key, null);
  }

  return state;
}).register();
var _default = PinnedEngagementsStore;
exports.default = _default;
module.exports = exports.default;